import { Typography } from '@material-ui/core';
import React, { PropsWithChildren } from 'react';

interface PageTitleProps extends PropsWithChildren<{ className?: string }> {
  'data-test'?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const PageTitle: React.FC<PageTitleProps> = ({ className, children, style, 'data-test': dataTest }) => (
  <Typography component="span" className={className} style={style} variant="h1" data-test={dataTest}>
    {children}
  </Typography>
);

export default PageTitle;
